export default __webpack_public_path__ + "static/media/Regi.738ded41.png";